import React from 'react'
import Loadable from 'react-loadable'
import ScreenLoader from './components/ScreenLoader'

const MainContainer = () => {
  return Loadable({
    loader: () => import('./containers/MainContainer'),
    loading: () => <div/>,
  })
}

const route = ({ children }) => (
    <div>
        <div>
            {children}
        </div>
    </div>
)

const createRoutes = () => ([
  {
    path: '/',
    component: route,
    indexRoute: MainContainer,
  },
  {
    path: '/redirect',
    component: ScreenLoader,
    indexRoute: () => null,
  },
])

export default createRoutes



// WEBPACK FOOTER //
// ./main/src/routes.js